import { createFileRoute } from '@tanstack/react-router';
import { UserType } from '../../../../types';
import { submissionRouteLoader } from '../../../../utils/submission-route-loader';
import SurveySignerWithToken from '../../../../components/pages/survey-signer-with-token';

export const Route = createFileRoute('/$accountSlug/$submissionId/signer-token/$token')({
  ...submissionRouteLoader(UserType.SIGNER, (accountSlug, submissionId) => `/${accountSlug}/${submissionId}/signer`),
  component: SurveySignerWithToken,
});
